import { render, staticRenderFns } from "./AddressBooksFilter.vue?vue&type=template&id=e810f994&"
import script from "./AddressBooksFilter.vue?vue&type=script&lang=ts&"
export * from "./AddressBooksFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports